export const languages = [
    { label: "हिं", value: "hi", text: "हिंदी" },
    { label: "EN", value: "en", text: "English" }
];